import React, { useState } from 'react';
import { connect } from 'react-redux';
import { KFLButton, KFLDialog } from '@kamstrup/kamstrup-frontend-library';
import { ReduxState } from '../../interfaces';
import * as Actions from '../../modules/devices/actions';
import * as Devices from '../../modules/devices';
import DialogFooter from '../shared/dialog/dialogFooter';
import DialogHeader from '../shared/dialog/dialogHeader';
import Translate from '../shared/localization/localize';
import { AppKeys, newMsg } from '../../core/localization';
import useDialog from '../shared/dialog/useDialog';

interface StateProps {
  selectedKeys: string[];
  actionStatus: Devices.ActionStatus;
}

type IProps = StateProps;

const RemoveDialog: React.FC<IProps> = (props) => {
  const {setDialog} = useDialog();
  const [error] = useState('');

  const infoText = (
    <Translate
      message={newMsg(AppKeys.Dialog_Remove_summary, [
        { tag: 'count', value: props.selectedKeys.length },
      ])}
    />
  );

  const onClick = () => Actions.deactivate(props.selectedKeys);
  const removeButton = (
    <KFLButton
      id="dg-remove-bt-remove"
      key="md-remove-bt-remove"
      onClick={onClick}
    >
      <Translate message={newMsg(AppKeys.Btn_Remove)} />
    </KFLButton>
  );
  const buttons: JSX.Element[] = [removeButton];

  const footerText = props.actionStatus.isDeactiving ? (
    <Translate message={newMsg(AppKeys.Dialog_Remove_fetching)} />
  ) : (
    <span style={{ color: 'red' }}>{error}</span>
  );

  return (
      <KFLDialog
        header={
          <DialogHeader
            title={<Translate message={newMsg(AppKeys.Dialog_Remove_Header)} />}
            fnCloseDialog={() => setDialog?.()}
          />
        }
        sections={[infoText]}
        footer={
          <DialogFooter
            leftContent={footerText}
            buttons={buttons}
            fnCloseDialog={() => setDialog?.()}
          />
        }
      />
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  selectedKeys: state.devicesState.selection.selectedKeys,
  actionStatus: state.devicesState.actionStatus,
});

export default connect(mapStateToProps)(RemoveDialog);
